import { QueryStatus } from 'src/types'
import { useEffect, useState } from 'react'
import {CLFBDetalle, CLFBLimiteAprobado, CLFBLimitesAprobadosPais} from "../types/types";
import {HttpCLFB} from "../api/HttpCLFB";
import {FormFiltros} from "../../../../limites/FiltrosBusqueda";

export const useLimitesAprobadosCLFB = (filtros: FormFiltros) => {
    const [data, setData] = useState<CLFBLimitesAprobadosPais[]>()
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)

    const fetch = () => {
        setStatus(QueryStatus.Loading)

        HttpCLFB.getLimitesAprobados(filtros)
            .then(value => {
                setData(value)
                setStatus(QueryStatus.Success)
            })
            .catch(e => {
                setStatus(QueryStatus.Error)
            })
    }

    const refetch = () => fetch()


    useEffect(() => {
        fetch()
    }, [filtros])

    return { data, refetch, status}
}
